import fetch from '@/common/axios';
export const ACCOUNT = '//account.wps.cn';
export const EDU = '//api-edu.wps.cn';
import md5 from 'js-md5';
import { Message } from '@kdocs/kdesign-vue';

/**
 * 获取用户账号信息
 */
export const queryUserInfo = async () => {
  let finalData = null;

  try {
    const result = await fetch.post('https://account.wps.cn/p/auth/check');
    finalData = result;
    window.dw.setAccountId(md5('' + finalData.userid));
  } catch (e) {
    console.log('获取用户账号信息失败', e);
    if (e.result === 'userNotLogin') {
      window.dw.setAccountId('');
    }
  }

  return finalData;
};

// 退出登录
export const logout = () => {
  return fetch.post(`//account.wps.cn/p/logout`, {
    timestamp: +new Date(),
  });
};

// 获取图文分页数据
// 投放位标识:
// 首页——客户案例模块_基础教育  official_website_home_casemodule_christianity
// 首页——客户案例模块_高等教育  official_website_home_casemodule_higheducation
// 客户案例页——banner  official_website_casepage_banner
// 客户案例页——基础教育分类tab  official_website_casepage_christianity
// 客户案例页——高等教育分类tab  official_website_casepage_higheducation
export const officialTextQuery = async (params) => {
  const result = await fetch.get(
    `${EDU}/operation-api/official/image/text/query?pos=${params.pos}&pageNum=${params.pageNum}&pageSize=${params.pageSize}`,
  );
  if (result.code !== 200) {
    return Message({
      message: '请求异常，请稍后再试！',
      type: 'error',
    });
  }
  return result.data;
};
